import * as L from 'leaflet';
import {
  ParamsCreateCircleMarker,
  ResponseCreateCircleMarker,
} from '../models/manager-leaflet.model';

const DEFAULT_OPTIONS: L.CircleMarkerOptions = {
  radius: 8,
  fillColor: '#1976D2',
  fillOpacity: 0.95,
  color: '#000',
  weight: 1,
  opacity: 1,
};

export function createCircleMarker(
  params: ParamsCreateCircleMarker
): ResponseCreateCircleMarker {
  try {
    const error = managerValidations(params);
    if (error) {
      return {
        circleMarker: L.circleMarker([0, 0]),
        error,
      };
    }

    const finalOptions: L.CircleMarkerOptions = {
      ...DEFAULT_OPTIONS,
      ...(params.options ?? {}),
    };

    const circleMarker = L.circleMarker(
      [params.coordinates.latitude, params.coordinates.longitude],
      finalOptions
    );

    if (!circleMarker) {
      return {
        circleMarker: L.circleMarker([0, 0]),
        error: 'No se pudo crear el circleMarker',
      };
    }

    // RAFA: EN CASO Q SE LENTEE MUCHO QUIZAS PUEDE SER POR ESTE CODIGO
    const baseRadius = finalOptions.radius ?? 7;
    const baseWeight = finalOptions.weight ?? 2;
    const baseFillOpacity = finalOptions.fillOpacity ?? 0.95;
    circleMarker.on('mouseover', () => {
      circleMarker.setRadius(Math.round(baseRadius * 1.15));
      circleMarker.setStyle({
        weight: baseWeight + 2,
        fillOpacity: Math.min(1, baseFillOpacity),
      });
      circleMarker.bringToFront();
    });
    circleMarker.on('mouseout', () => {
      circleMarker.setRadius(baseRadius);
      circleMarker.setStyle({
        weight: baseWeight,
        fillOpacity: baseFillOpacity,
      });
    });

    return { circleMarker, error: null };
  } catch (error) {
    return {
      circleMarker: L.circleMarker([0, 0]),
      error: 'Error desconocido al crear circleMarker',
    };
  }
}

function managerValidations(params: ParamsCreateCircleMarker): string | null {
  const { coordinates } = params;
  const { latitude, longitude } = coordinates;

  if (typeof latitude !== 'number' || typeof longitude !== 'number') {
    return 'Las coordenadas deben ser números válidos';
  }

  if (isNaN(latitude) || isNaN(longitude)) {
    return 'Las coordenadas no pueden ser NaN';
  }

  if (latitude < -90 || latitude > 90) {
    return 'La latitud debe estar entre -90 y 90';
  }

  if (longitude < -180 || longitude > 180) {
    return 'La longitud debe estar entre -180 y 180';
  }

  return null;
}
